import { BasicRequest } from "./basicRequest";

export class DeleteMoovVariableRequest extends BasicRequest{
    
    public moovVariableId!:number

    constructor(){
        super();
    }
}